import { type FetchResponse } from '@sydle/ui-api';
import { blogCustomAPI } from './index';

export interface sendSuggestionInput {
  ticketClassification: string;
  message: string;
}

export interface sendSuggestionOutput {
  title: string;
  message: string;
}

export async function sendSuggestion(input: sendSuggestionInput): Promise<FetchResponse<sendSuggestionOutput>> {
  const response = await blogCustomAPI.fetch<sendSuggestionInput, any>(
    'sendSuggestion',
    {
      ...input,
    },
    { forcePost: true },
  );

  return response;
}
